import AddForm from "../../components/AddMovieForm/AddMovieForm";
import Hero from "../../components/Hero/Hero";

function CreateMovie() {
    return (
        <>
            <Hero />
            <AddForm />   
        </>
    );
}

export default CreateMovie;